import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

import { analyticsEventCategories, type AnalyticsEventProps, type ClientAnalyticsEventName } from './generated/events';

type TrackEventArgs<E extends ClientAnalyticsEventName> = AnalyticsEventProps[E] extends undefined
  ? []
  : Record<string, never> extends AnalyticsEventProps[E]
    ? [props?: AnalyticsEventProps[E]]
    : [props: AnalyticsEventProps[E]];

export function trackEvent<E extends ClientAnalyticsEventName>(event: E, ...args: TrackEventArgs<E>): void {
  createTrackerForCategory(analyticsEventCategories[event])(event, args[0]);
}
